import "./style.css";

const LoadingScreen = () => {
    return (
      <div className="loading-screen">
        <div className="loading-overlay"></div>
        <div className="loading-spinner"></div>
      </div>
    );
  };

export default LoadingScreen;  
  